import React from "react";
import PropTypes from "prop-types";
import { useFinaidYear } from "components/hooks/useFinaidYear";
import formatCurrency from "functions/formatCurrency";

export function GrandTotal({ showDecimals }) {
  const finaidAwards = useFinaidYear(({ finaidAwards }) => finaidAwards) || {};

  const {
    awards: {
      grandtotal: { total: { amount: grandTotalAmount } = {} } = {},
    } = {},
  } = finaidAwards;

  return (
    <div style={{}}>
      <h3 style={{ fontSize: `14px`, paddingLeft: `var(--large-spacing)` }}>
        Grand Total
      </h3>
      <div
        style={{
          borderTop: `1px solid var(--gallery)`,
          padding: `var(--large-spacing)`,
          textAlign: `right`,
          fontSize: `16px`,
          fontWeight: `bold`,
        }}
      >
        {formatCurrency(grandTotalAmount, { showDecimals })}
      </div>
    </div>
  );
}

GrandTotal.displayName = "GrandTotal";
GrandTotal.propTypes = {
  showDecimals: PropTypes.bool,
};
